<template>
  <div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-header pb-0">
                    <div class="d-flex justify-content-between">
                        <div class="d-grid gap-2 d-flex">
                            <button 
                                class="btn btn-xs btn-primary text-xs font-weight-normal m-0"
                                data-bs-toggle="modal"
                                data-bs-target="#modalBid"
                                v-if="tender && tender.state_value === 'bid_selection' && !already_bid && tender.can_bid">
                                <i class="fa fa-pencil-square-o" aria-hidden="true"></i> Add Bid
                            </button>
                            <button
                                v-if="!rfp_rejected" 
                                type="button"
                                @click="download"
                                :class="'btn btn-xs btn-outline-primary text-xs font-weight-normal m-0 ' + (loading ? 'disabled' : '')">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                                <i class="fa fa-download" v-if="!loading"></i> Download
                            </button>
                        </div>
                        <div class="d-grid gap-2 d-flex" v-if="!rfp_rejected">
                            <argon-badge color="success" class="text-xxs align-self-center" v-if="tender">{{ tender.stage_name }}</argon-badge>
                            <argon-badge color="info" class="text-xxs align-self-center" v-if="tender">{{ tender.state }}</argon-badge>
                        </div>
                        <argon-badge color="danger" class="text-xxs align-self-center" v-else>REJECTED</argon-badge>
                    </div>
                    <hr/>
                </div>
                <div class="card-body min-vh-50 pt-0" v-if="tender">
                    <h5>{{ tender.tender_name }}</h5>
                    <div class="row">
                        <div class="col-12">
                            <p class="text-secondary text-sm mb-1">Description</p>
                            <p class="fw-bold text-sm">{{ tender.description }}</p>
                        </div>
                        <div class="col-sm-6">
                            <table class="text-sm" width="100%">
                                <tbody>
                                    <tr>
                                        <td class="text-secondary align-top" width="40%">Tender Deadline</td>
                                        <td class="fw-bold align-top">{{ tender.sh_agreement_deadline }}</td>
                                    </tr>
                                    <tr>
                                        <td class="text-secondary align-top">Ordering Date</td>
                                        <td class="fw-bold align-top">{{ tender.sh_order_date }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-sm-6">
                            <table class="text-sm" width="100%">
                                <tbody>
                                    <tr>
                                        <td class="text-secondary align-top" width="40%">Last Date of Portal Access</td>
                                        <td class="fw-bold align-top">{{ tender.sh_last_date_of_portal_access }}</td>
                                    </tr>
                                    <tr>
                                        <td class="text-secondary align-top">Delivery Date</td>
                                        <td class="fw-bold align-top">{{ tender.sh_delivery_date }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="table-responsive p-0 my-3">
                        <table class="table align-items-center mb-0">
                            <thead>
                                <tr class="bg-light">
                                    <th class="text-uppercase text-xs fw-bolder opacity-7 ps-2">#</th>
                                    <th class="text-uppercase text-xs fw-bolder opacity-7 ps-2">Product</th>
                                    <th class="text-uppercase text-xs fw-bolder opacity-7 ps-2">Quantity</th>
                                    <th class="text-uppercase text-xs fw-bolder opacity-7 ps-2">Unit of Measure</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="line,i in tender_lines" :key="line.agreement_line_id">
                                    <td class="text-sm mb-0 ps-2">{{ i+1 }}</td>
                                    <td>
                                        <p class="text-sm mb-0">{{ line.product_name }}</p>
                                    </td>
                                    <td>
                                        <p class="text-sm text-end mb-0">{{ line.sh_qty }}</p>
                                    </td>
                                    <td>
                                        <p class="text-sm mb-0">{{ line.uom_name }}</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <label for="name">Documents</label>
                    <div class="table-responsive p-0">
                        <table class="table align-items-center mb-0">
                            <thead>
                                <tr class="bg-light">
                                    <th class="text-uppercase text-xs fw-bolder opacity-7 ps-2">#</th>
                                    <th class="text-uppercase text-xs fw-bolder opacity-7 ps-2">Document Name</th>
                                    <th class="text-uppercase text-xs fw-bolder opacity-7 ps-2">Submission Deadline</th>
                                    <th class="text-uppercase text-xs fw-bolder opacity-7 ps-2">Required</th>
                                </tr>
                            </thead>
                            <tbody>
                              <tr v-for="line,i in tender_documents" :key="line.agreement_line_id">
                                <td class="text-sm mb-0 ps-2">{{ i+1 }}</td>
                                <td>
                                  <p class="text-sm mb-0">{{ line.document_name }}</p>
                                </td>
                                <td>
                                  <p class="text-sm mb-0">{{ line.deadline }}</p>
                                </td>
                                <td>
                                  <argon-badge color="danger" class="text-xxs align-self-center" v-if="line.required">Required</argon-badge>
                                </td>
                              </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- modal bid -->
    <div class="modal fade" id="modalBid"  tabindex="-1" aria-labelledby="modalBidLabel" aria-hidden="true" v-if="tender">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <p class="modal-title" id="modalBidLabel">Bidding</p>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6">
                <label for="name">Estimated Delivery Date</label>
                <Datepicker 
                  v-model="modal.vendor_estimated_date" 
                  :min-date="tender.sh_delivery_date ? tender.sh_delivery_date : false"
                  format="dd/MM/yyyy"/>
              </div>
              <div class="col-md-6">
                <label for="name">Note</label>
                <input v-model="modal.note" type="text" class="form-control form-control-sm">
              </div>
            </div>
            <div class="col-md">
              <label for="name">Detail</label>
              <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr class="bg-light">
                      <th class="text-uppercase text-xxs fw-bolder" width="5%">#</th>
                      <th
                        class="text-uppercase text-xxs fw-bolder ps-2"
                      >Product</th>
                      <th
                        class="text-uppercase text-xxs fw-bolder ps-2"
                      >Qty</th>
                      <th
                        class="text-uppercase text-xxs fw-bolder ps-2"
                      >UoM</th>
                      <th
                        class="text-uppercase text-xxs fw-bolder ps-2"
                      >Unit Price (Exclude VAT)</th>
                    </tr>
                  </thead>
                  <tbody>
                      <tr v-for="prod,i in tender_lines" :key="prod.agreement_line_id">
                        <td class="text-sm mb-0 ps-2 text-center">{{ i+1 }}</td>
                        <td>
                            <p class="text-sm mb-0">{{ prod.product_name }}</p>
                        </td>
                        <td>
                            <p class="text-sm text-end mb-0">{{ prod.sh_qty }}</p>
                        </td>
                        <td>
                            <p class="text-sm mb-0">{{ prod.uom_name }}</p>
                        </td>
                        <td>
                          <input 
                              :ref="'vendorPrice' + prod.agreement_line_id.split('_')[0]" 
                              class="form-control form-control-sm mb-0" 
                              type="number"
                              />
                        </td>
                      </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-md">
              <label for="name">Documents</label>
              <div class="table-responsive p-0">
                  <table class="table align-items-center mb-0">
                      <thead>
                          <tr class="bg-light">
                              <th class="text-uppercase text-xs fw-bolder opacity-7 ps-2">#</th>
                              <th class="text-uppercase text-xs fw-bolder opacity-7 ps-2">Document Name</th>
                              <th class="text-uppercase text-xs fw-bolder opacity-7 ps-2">Submission Deadline</th>
                              <th class="text-uppercase text-xs fw-bolder opacity-7 ps-2">Required</th>
                              <th></th>
                              <th></th>
                          </tr>
                      </thead>
                      <tbody>
                        <tr v-for="line,i in documents_mapped" :key="line.agreement_line_id">
                          <td class="text-sm mb-0 ps-2">{{ i+1 }}</td>
                          <td>
                            <p class="text-sm mb-0">{{ line.document_name }}</p>
                          </td>
                          <td>
                            <p class="text-sm mb-0">{{ line.deadline }}</p>
                          </td>
                          <td>
                            <argon-badge color="danger" class="text-xxs align-self-center" v-if="line.document_required">Required</argon-badge>
                          </td>
                          <template v-if="line.url_data || line.file">
                            <td>
                              <a :href="line.url_data" target="_blank">{{ line.filename }}</a>
                            </td>
                            <td>
                              <button class="btn btn-link text-danger btn-xs p-0" @click="clearDoc(i)">
                                <i class="fa text-sm fa-times" aria-hidden="true"></i> Clear
                              </button>
                            </td>
                          </template>
                          <template v-else>
                            <td>
                              <input type="file" class="form-control" :accept="allowed_extensions" :required="line.document_required" :ref="'documentUpload' + line.agreement_document_id" @change="getDocumentTender($event,i)"/>
                            </td>
                          </template>
                        </tr>
                      </tbody>
                  </table>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <!-- v-if="uploaded" -->
            <p class="text-danger fst-italic fw-bold text-sm">Note : Maximum file size that can be uploaded is 20 MB (all tender supporting documents)</p>
            <button type="button" :class="'btn btn-xs btn-primary ' + (loading ? 'disabled' : '')" @click="bid">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
              Submit Bid
            </button>
            <!-- <button type="button" :class="'btn btn-xs btn-outline-primary ' + (loading_upload ? 'disabled' : '')" @click="uploadDocument">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading_upload"></span>
              <i class="fa fa-upload"></i> Upload
            </button> -->
            <button ref="discardBid" type="button" class="btn btn-xs btn-outline-secondary" data-bs-dismiss="modal">Discard</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArgonBadge from '../components/ArgonBadge.vue'
const endpoint = require("../router/endpoint");

export default {
  name: "tender-detail",
  data() {
    return {
      tender: null,
      uploaded: false,
      tender_documents: [],
      bidding_documents: [], // aggregasi documents
      documents_mapped: [],
      loading: false,
      loading_upload: false,
      receipt_date: null,
      edit: false, // true = editable, false = readonly
      tender_lines: [],
      order_line: [],
      bid_line_ids: [],
      already_bid: true,
      rfp_rejected: false,
      allowed_extensions: localStorage.getItem('allowed_extensions'),
      modal: {
        note: '',
        vendor_estimated_date: '',
        document_tender: '',
        document_tender_name: '',
      }
    };
  },
  components: {
    ArgonBadge
  },
  methods: {
    bid() {
      const totalFileSize = this.documents_mapped.reduce((sum, document) => {
        // Periksa apakah document.file_size terdefinisi dan memiliki nilai numerik
        if (document.file_size !== undefined && typeof document.file_size === 'number' && !isNaN(document.file_size)) {
          return sum + document.file_size;
        } else {
          // Jika tidak valid, kembalikan nilai sum tanpa penambahan
          return sum;
        }
      }, 0);
      let limit_file = localStorage.getItem('limit_file') || 20; // default 20 jika tidak ada nilai dari localStorage
      const maxSizeInBytes = limit_file * 1024 * 1024; // Konversi MB ke bytes
      if (totalFileSize > maxSizeInBytes) {
        this.$notify({
          type: 'warn',
          title: 'Warning!',
          text: `File size exceeds the maximum allowed size (${limit_file} MB). Please choose a smaller file.`,
        });
        this.bid_line_ids = []
      } else {
        this.bid_line_ids = []
        this.tender_lines.forEach(prod => {
          // if (this.bid_line_ids.length != this.tender_lines.length) {
          if (parseFloat(this.$refs['vendorPrice'+prod.agreement_line_id.split('_')[0]].value) > 0) {
            this.bid_line_ids.push({
              'agreement_id': parseInt(prod.agreement_id.split('_')[0]),
              'agreement_line_id': parseInt(prod.agreement_line_id.split('_')[0]),
              'product_id': parseInt(prod.sh_product_id.split('_')[0]),
              'uom_id': parseInt(prod.uom_id.split('_')[0]),
              'qty': prod.sh_qty,
              'price_unit': parseFloat(this.$refs['vendorPrice'+prod.agreement_line_id.split('_')[0]].value),
            })
          }
          // }
        });
        if (!this.modal.vendor_estimated_date || this.bid_line_ids.length <= 0) {
          this.bid_line_ids = []
          this.$notify({
              type: 'warn',
              title: 'Warning!',
              text: 'Estimated Delivery Date, File Document, and Price are required. Please fill all data correctly!',
            });
          this.loading = false
          return
        } else {
          this.uploadDocument().then((res) => {
            if (res) {
              this.submitBid();
            }
          });
        }
      }
    },
    alreadyBid(tender_name) {
      this.axios
        .post(
          endpoint.BIDDING_LIST,
          {
            name: tender_name,
            partner_id: parseInt(localStorage.getItem("partner_id")),
            limit: 1,
            offset: 0,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.msg_status === "0002"){
              this.$notify({
                type: 'warn',
                title: 'Expired',
                text: 'Session expired, please sign in again.',
              });
              this.$router.replace('/signin')
              return false
          } else if (response.data.response_code === "0000") {
            // this.tender = response.data.data;
            this.already_bid = response.data.data.length > 0 ? true : false
            this.rfp_rejected = response.data.data.every(function(rfp){ return rfp.state_value === 'rejected'})
          } else {
            this.already_bid = false
            this.rfp_rejected = false
          }
        })
        .catch((e) => {
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message || e,
          });
        });
    },
    getTenderDetail() {
      this.loading = true
      this.axios
        .post(
          endpoint.TENDER_LIST,
          {
            tender_id: parseInt(this.$route.params.id.split('_')[0]),
            partner_id: parseInt(localStorage.getItem("partner_id")),
            limit: 1,
            offset: 0,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.msg_status === "0002"){
              this.$notify({
                type: 'warn',
                title: 'Expired',
                text: 'Session expired, please sign in again.',
              });
              this.$router.replace('/signin')
              return false
          } else if (response.data.response_code === "0000") {
            this.tender = response.data.data[0];
            this.loading = false;
            this.alreadyBid(response.data.data[0].tender_name)
          } else {
            if (response.data.response_code !== "4000"){
            this.$notify({
                type: 'warn',
                title: 'Warning',
                text: response.data.message,
            });}
            this.loading = false;
          }
        })
        .catch((e) => {
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message || e,
          });
          this.loading = false;
          this.$router.replace('/tender')
        });
    },
    getTenderLines() {
      this.loading = true
      this.axios
        .post(
          endpoint.TENDER_LINES,
          {
            partner_id: parseInt(localStorage.getItem('partner_id')),
            agreement_id: parseInt(this.$route.params.id.split('_')[0]),
            limit: 1000,
            offset: 0,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.msg_status === "0002"){
              this.$notify({
                type: 'warn',
                title: 'Expired',
                text: 'Session expired, please sign in again.',
              });
              this.$router.replace('/signin')
              return false
          } else if (response.data.response_code === "0000") {
            this.tender_lines = response.data.data;
            this.loading = false;
          } else {
            if (response.data.response_code !== "4000"){
            this.$notify({
                type: 'warn',
                title: 'Warning',
                text: response.data.message,
            });}
            this.loading = false;
          }
        })
        .catch((e) => {
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message || e,
          });
          this.loading = false;
          this.$router.replace('/tender')
        });
    },
    getDocumentList() {
      this.loading = true
      this.axios
        .post(
          endpoint.TENDER_DOCUMENT,
          {
            partner_id: parseInt(localStorage.getItem('partner_id')),
            agreement_id: parseInt(this.$route.params.id.split('_')[0]),
            limit: 1000,
            offset: 0,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.msg_status === "0002"){
              this.$notify({
                type: 'warn',
                title: 'Expired',
                text: 'Session expired, please sign in again.',
              });
              this.$router.replace('/signin')
              return false
          } else if (response.data.response_code === "0000") {
            this.tender_documents = response.data.data;
            this.loading = false;
            this.getBiddingDocumentList(response.data.data)
          } else {
            if (response.data.response_code !== "4000"){
            this.$notify({
                type: 'warn',
                title: 'Warning',
                text: response.data.message,
            });}
            this.loading = false;
          }
        })
        .catch((e) => {
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message || e,
          });
          this.loading = false;
          this.$router.replace('/tender')
        });
    },
    getDocumentTender(event, index) {
      const fileInput = this.$refs['documentUpload' + this.documents_mapped[index].agreement_document_id];

      const file = event.target.files[0];

      // Validasi ukuran file maksimum berdasarkan limit dari localStorage
      let limit_file = localStorage.getItem('limit_file') || 20; // default 20 jika tidak ada nilai dari localStorage
      const maxSizeInBytes = limit_file * 1024 * 1024; // Konversi MB ke bytes
      if (file.size > maxSizeInBytes) {
        // Tampilkan pesan atau ambil tindakan yang sesuai
        this.$notify({
          type: 'warn',
          title: 'Warning!',
          text: `File size exceeds the maximum allowed size (${limit_file} MB). Please choose a smaller file.`,
        });

        // Kosongkan input file
        this.documents_mapped[index].file = null;

        // Set nama file ke string kosong
        this.documents_mapped[index].filename = '';

        // Kosongkan nilai input file di DOM
        fileInput.value = null;

        return;
      }
      this.documents_mapped[index].file_size = file.size;
      const reader = new FileReader();
      reader.onload = e => { 
        this.documents_mapped[index].file = e.target.result.split(',')[1];
      };

      reader.readAsDataURL(file);
      this.documents_mapped[index].filename = file.name;
    },
    getBiddingDocumentList(tender_documents) {
      this.loading = true
      this.axios
        .post(
          endpoint.BIDDING_DOCUMENT,
          {
            partner_id: parseInt(localStorage.getItem('partner_id')),
            agreement_id: parseInt(this.$route.params.id.split('_')[0]),
            limit: 100000,
            offset: 0,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.msg_status === "0002"){
              this.$notify({
                type: 'warn',
                title: 'Expired',
                text: 'Session expired, please sign in again.',
              });
              this.$router.replace('/signin')
              return false
          } else if (response.data.response_code === "0000") {
            const date_now = new Date
            let day = date_now.getDate();
            let month = date_now.getMonth() + 1;
            let year = date_now.getFullYear();

            response.data.data.forEach(bid_doc => {
              tender_documents.forEach(te_doc => {
                if ( bid_doc.document_id.split('_')[0] === te_doc.document_type_id.split('_')[0] ) {
                  this.documents_mapped.push({
                    agreement_document_id: parseInt(te_doc.agreement_document_id.split('_')[0]),
                    document_name: te_doc.document_name,
                    document_id: bid_doc.document_id ? bid_doc.document_id.split('_')[0] : 0,
                    filename: bid_doc.filename,
                    url_data: bid_doc.url_data,
                    document_required: te_doc.required,
                    deadline: te_doc.deadline,
                    upload_date: `${year}-${month}-${day}`,
                    document_vendor_id: bid_doc.document_vendor_id ? bid_doc.document_vendor_id.split('_')[0] : 0,
                  })
                }
              });
            });
            this.loading = false;
          } else {
            if (response.data.response_code !== "4000"){
            this.$notify({
                type: 'warn',
                title: 'Warning',
                text: response.data.message,
            });}
            this.loading = false;
          }
        })
        .catch((e) => {
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message || e,
          });
          this.loading = false;
          this.$router.replace('/tender')
        });
    },
    clearDoc(index) {
      this.documents_mapped[index].url_data = null
      this.documents_mapped[index].file = null
      this.documents_mapped[index].filename = null
      this.documents_mapped[index].file_size = null
    },
    async uploadDocument() {
      try {
        this.loading = true
        this.loading_upload = true;
        var req_empty = 0;

        for (const doc of this.documents_mapped) {
          if (doc.document_required) {
            if (!doc.file && !doc.url_data) {
              req_empty = req_empty + 1;
            }
          }
        }

        if (req_empty > 0) {
          this.$notify({
            type: 'warn',
            title: 'Warning!',
            text: 'Required documents must be uploaded!',
          });
          this.loading_upload = false;
          this.loading = false;
          return false;
        }

        var self = this;

        for (const [i, doc] of this.documents_mapped.entries()) {
          if (doc.file) {
            const params = {
              files_to_upload: doc.file,
              file_to_upload_filename: doc.filename,
              model_name: 'bh.document.vendor',
              model_id: parseInt(doc.document_vendor_id),
              partner_id: parseInt(localStorage.getItem('partner_id')),
              document_id: parseInt(doc.document_id),
              required: doc.document_required,
            };

            try {
              const response = await self.axios.post(
                endpoint.UPLOAD_DOCUMENT,
                params,
                {
                  headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                  },
                }
              );

              if (response.data.msg_status === '0002') {
                this.$notify({
                  type: 'warn',
                  title: 'Expired',
                  text: 'Session expired, please sign in again.',
                });
                this.$router.replace('/signin');
                return false;
              } else if (response.data.response_code === '0000') {
                self.documents_mapped[i].url_data = response.data.data.url_data;
                self.documents_mapped[i].file = null;
                self.documents_mapped[i].filename = null;
                // self.loading_upload = false;
                // self.loading = false;
                // self.uploaded = true;
              } else {
                if (response.data.response_code !== '4000') {
                  self.$notify({
                    type: 'warn',
                    title: 'Warning',
                    text: response.data.message,
                  });
                }
                self.loading_upload = false;
                self.loading = false;
                return false;
              }
            } catch (e) {
              if (e.response && e.response.status === 413) {
                // Handle error 413 Payload Too Large
                self.$notify({
                  type: 'error',
                  title: 'Payload Too Large',
                  text: 'The file size is too large. Please upload a smaller file.',
                });
              } else {
                // Handle other errors
                self.$notify({
                  type: 'error',
                  title: 'Something went wrong!',
                  text: e.response.data.message || e,
                });
              }
              self.loading_upload = false;
              self.loading = false;
              return false;
            }
          }
        }

        return true;
      } catch (error) {
        console.error('Error in uploadDocument:', error);
        self.loading_upload = false;
        self.loading = false;
        self.bid_line_ids = []
        return false;
      }
    },
    getDate(date) {
      let month = date.getMonth() >= 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
      let fullDate = date.getFullYear() + '-' + month + '-' + date.getDate()
      return fullDate
    },
    download () {
      this.loading = true
      this.axios
          .post(
          endpoint.DOWNLOAD,
          {
            partner_id: parseInt(localStorage.getItem('partner_id')),
            res_id: parseInt(this.$route.params.id.split('_')[0]),
            template_report: 'bh_all_in_one_tender_bundle.action_report_purchase_tender'
          },
          {
              headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
              }
          }
          )
          .then((response) => {
          if (response.data.msg_status === "0002"){
              this.$notify({
                type: 'warn',
                title: 'Expired',
                text: 'Session expired, please sign in again.',
              });
              this.$router.replace('/signin')
              return false
          } else if (response.data.response_code === "0000") {
              const linkSource = `data:application/pdf;base64,${response.data.data.file}`;
              const downloadLink = document.createElement("a");
              const fileName = this.tender.tender_name + ".pdf";
              downloadLink.href = linkSource;
              downloadLink.download = fileName;
              downloadLink.click();
          } else {
              if (response.data.response_code !== "4000"){
              this.$notify({
                  type: 'warn',
                  title: 'Warning',
                  text: response.data.message,
              });
              }
          }
          this.loading = false
          })
          .catch((e) => {
          this.loading = false;
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message || e,
              });
          });
      },
    async submitBid() {
      this.loading = true
      const params = {
          agreement_id: parseInt(this.$route.params.id.split('_')[0]),
          estimated_date: this.getDate(this.modal.vendor_estimated_date),
          note: this.modal.note,
          bid_line_ids: this.bid_line_ids,
          currency_id: parseInt(this.tender.currency_id.split('_')[0]),
          partner_id: parseInt(localStorage.getItem('partner_id')),
          bid_document_ids: this.documents_mapped,
          is_pkp: localStorage.getItem('is_pkp'),
          limit: 0,
          offset: 0
        }
      this.axios
      .post(
        endpoint.TENDER_SUBMIT,
        params,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        }
      )
      .then((response) => {
        if (response.data.msg_status === "0002"){
              this.$notify({
                type: 'warn',
                title: 'Expired',
                text: 'Session expired, please sign in again.',
              });
              this.$router.replace('/signin')
              return false
        } else if (response.data.response_code === "0000") {
          // success
          this.loading = false
          this.$notify({
            type: 'success',
            title: 'Voila!',
            text: 'Successfully Submit Bidding',
          });
          this.$refs.discardBid.click();
          this.$router.replace('/request-for-proposal/' + response.data.data.insert_purchase_agreement_bid)
        } else {
          // sys error
          this.loading = false;
          this.$notify({
            type: 'error',
            title: 'Oops!',
            text: response.data.message,
          });
          this.$refs.discardBid.click();
        }
      })
      .catch((e) => {
        this.loading = false;
        this.$notify({
            type: 'error',
            title: 'Error!',
            text: e.response.data.message || e,
          });
        this.$refs.discardBid.click();
      });
    }
  },
  mounted() {
    this.getTenderDetail();
    this.getTenderLines();
    this.getDocumentList();
  }
};
</script>

<style scoped>
  .btn {
    margin-bottom: 0 !important; 
    letter-spacing: 0 !important;
  }
</style>